// Update this file with your actual business information
const seoConfig = {
  // Basic Site Info
  siteName: 'Faheem Graphics',
  siteUrl: 'https://www.faheemkhangraphics.com', // Replace with your actual domain
  twitterHandle: '@faheemgraphics',
  defaultImage: '/images/og-image.png', // 1200x630px social media image
  favicon: '/favicon.ico',
  
  // Business Information
  businessName: 'Faheem Graphics',
  businessDescription: 'Professional graphic design services specializing in logo design, branding, and digital marketing materials.',
  businessAddress: {
    street: '123 Business Street',
    city: 'Karachi',
    region: 'Sindh',
    postalCode: '74000',
    country: 'Pakistan'
  },
  businessPhone: '+92 317 2642218',
  businessEmail: 'info@faheemgraphics.com',
  businessHours: [
    { day: 'Monday-Friday', hours: '9:00 AM - 6:00 PM' },
    { day: 'Saturday', hours: '10:00 AM - 4:00 PM' },
    { day: 'Sunday', hours: 'Closed' }
  ],
  
  // Social Media Profiles
  socialProfiles: {
    facebook: 'https://facebook.com/faheemgraphics',
    instagram: 'https://instagram.com/faheemgraphics',
    linkedin: 'https://linkedin.com/company/faheemgraphics',
    pinterest: 'https://pinterest.com/faheemgraphics',
    behance: 'https://behance.net/faheemgraphics'
  }
};

export default seoConfig;